/**
 * @prettier
 */
export const SCALAR_TYPES = ["number", "integer", "string", "boolean", "null"]

export const ALL_TYPES = ["array", "object", ...SCALAR_TYPES]
